import { render, staticRenderFns } from "./purchaseOrderForm.vue?vue&type=template&id=6882c271"
import script from "./purchaseOrderForm.vue?vue&type=script&lang=js"
export * from "./purchaseOrderForm.vue?vue&type=script&lang=js"
import style0 from "./purchaseOrderForm.vue?vue&type=style&index=0&id=6882c271&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports